import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import ReCAPTCHA from "react-google-recaptcha";
class Contact extends Component {

  state = {
    con_name: "",
    con_number: "",
    con_email: "",
    con_subject: "",
    con_message: "",
    loading: false,
    successMessage: "",
    errorMessage: "",
    captchaToken: ""
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  handleCaptcha = (token) => {
    this.setState({
      captchaToken: token
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    try {

      const response = await fetch("/api/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: this.state.con_name,
          phone: this.state.con_number,
          email: this.state.con_email,
          subject: this.state.con_subject,
          message: this.state.con_message,
          captcha: this.state.captchaToken
        })
      });

      const data = await response.json();

      if (data.success) {

        this.setState({
          con_name: "",
          con_number: "",
          con_email: "",
          con_subject: "",
          con_message: "",
          loading: false,
          successMessage: "Thank you! Your message has been sent successfully. We'll get back to you soon.",
          errorMessage: ""
        });

        setTimeout(() => {
          this.setState({ successMessage: "" });
        }, 5000);
      } else {

        this.setState({
          loading: false,
          errorMessage: data.message,
          successMessage: ""
        });

        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 5000);

      }

    } catch (err) {

      this.setState({
        loading: false,
        errorMessage: "Something went wrong. Please try again later.",
        successMessage: ""
      });

      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 5000);

    }
  };

  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Contact Us</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>Contact Us</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        {/*====================  content page content ====================*/}
        <div className="page-wrapper section-space--inner--120">
          {/*Contact section start*/}
          <div className="conact-section">
            <div className="container">
              <div className="row section-space--bottom--50">
                <div className="col">
                  <div className="contact-map">
                    <iframe
                      title="google-map"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.542948653295!2d77.00543979999999!3d28.493308000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d17eb67ce2355%3A0x584cc3fe0ffaa281!2sShakuntla%20Learn%20and%20Fly%20Foundation!5e0!3m2!1sen!2sin!4v1783321924711!5m2!1sen!2sin"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-12">
                  <div className="contact-information">
                    <h3>Get In Touch</h3>
                    <ul>
                      <li>
                        <span className="icon">
                          <i className="ion-android-map" />
                        </span>
                        <span className="text">
                          <span>
                            Plot No. 16, Khasra No. 108,
                            Rajendra Park, Block-B,
                            Gurugram, Haryana – 122001, India
                          </span>
                        </span>
                      </li>
                      <li>
                        <span className="icon">
                          <i className="ion-ios-telephone-outline" />
                        </span>
                        <span className="text">
                          <a href="tel:+919643532525">+91 96435 32525</a>
                        </span>
                      </li>
                      <li>
                        <span className="icon">
                          <i className="ion-ios-email-outline" />
                        </span>
                        <span className="text">
                          <a href="mailto:info@shakuntlafoundation.org">info@shakuntlafoundation.org</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-8 col-12">
                  <div className="contact-form">
                    <h3>Leave Your Message</h3>
                    {this.state.successMessage && (
                      <div className="alert alert-success mb-3" role="alert">
                        {this.state.successMessage}
                      </div>
                    )}

                    {this.state.errorMessage && (
                      <div className="alert alert-danger mb-3" role="alert">
                        {this.state.errorMessage}
                      </div>
                    )}
                    <form id="contact-form" onSubmit={this.handleSubmit}>
                      <div className="row row-10">
                        <div className="col-md-6 col-12 section-space--bottom--20">
                          <input
                            name="con_name"
                            type="text"
                            placeholder="Your Name"
                            value={this.state.con_name}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                        <div className="col-md-6 col-12 section-space--bottom--20">
                          <input
                            name="con_number"
                            type="number"
                            placeholder="Your Number"
                            value={this.state.con_number}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                        <div className="col-md-6 col-12 section-space--bottom--20">
                          <input
                            name="con_email"
                            type="email"
                            placeholder="Your Email"
                            value={this.state.con_email}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="col-md-6 col-12 section-space--bottom--20">
                          <input
                            name="con_subject"
                            type="text"
                            placeholder="Your Subject"
                            value={this.state.con_subject}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                        <div className="col-12">
                          <textarea
                            name="con_message"
                            placeholder="Your Message"
                            value={this.state.con_message}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                        <div className="col-12">
                          <div className="col-12 section-space--bottom--20">
                            <ReCAPTCHA
                              sitekey="6LfbyjstAAAAAHxqAfBoo6wdoaZPQ_cvazzRkE00"
                              onChange={this.handleCaptcha}
                            />
                          </div>
                          <button
                            type="submit"
                            disabled={this.state.loading || !this.state.captchaToken}
                          >
                            {this.state.loading ? "Sending..." : "Send Message"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Contact section end*/}
        </div>
        {/*====================  End of content page content  ====================*/}

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default Contact;
